module.exports = __webpack_public_path__ + "static/bg_fallback_mob-e7625a416fe933d70c38a44c80d2da93.jpg";